"use strict";

define('collection/assignments',['underscore', './base', '../model/assignment'], function (_, BaseCollection, Assignment) {
  var Assignments = BaseCollection.extend({
    urlTemplate: '/rs/api/assignment/:entityType/:entityId',
    model: Assignment,
    getByAssignmentTypeProp: function getByAssignmentTypeProp(value, prop) {
      return new Assignments(_.filter(this.models, function (m) {
        return m.get('assignmentType').get(prop).toLowerCase() == value.toLowerCase();
      }));
    },
    getByAssignmentTypeDescription: function getByAssignmentTypeDescription(value) {
      return this.getByAssignmentTypeProp(value, 'description');
    },
    getByFinderType: function getByFinderType(type) {
      return this.getByAssignmentTypeProp(type, 'finderType');
    },
    getPropByFinderType: function getPropByFinderType(type, prop) {
      var c = this.getByFinderType(type);
      return c.reduce(function (a, m) {
        return (a ? a + ', ' : '') + m.get(prop);
      }, '');
    },
    getPropByAssignmentType: function getPropByAssignmentType(assignmentType, prop) {
      var c = this.getByAssignmentTypeProp(assignmentType, 'description');
      return _.invoke(c.models, 'get', prop).join(', ');
    },
    requestGroupAssignments: function requestGroupAssignments(documentId) {
      var url = '/rs/api/assignment/group/' + documentId;
      return BaseCollection.prototype.sync.call(this, 'create', this, {
        url: url
      });
    },
    requestPropertyAssignments: function requestPropertyAssignments(documentId) {
      var url = '/rs/api/assignment/property/' + documentId;
      return BaseCollection.prototype.sync.call(this, 'create', this, {
        url: url
      });
    },
    requestPersonAssignments: function requestPersonAssignments(documentId) {
      var url = '/rs/api/assignment/person/document/' + documentId;
      return BaseCollection.prototype.sync.call(this, 'create', this, {
        url: url
      });
    }
  }, {
    collectionByAssignmentType: function collectionByAssignmentType() {
      return new Assignments([], {
        url: ' /rs/api/assignment/:entityType/:entityId/:assignmentType'
      });
    }
  });
  return Assignments;
});

